import React, {useState} from "react";
import {Segmented} from "antd";
import {AiOutlineDownload} from "react-icons/ai";
import {MdContentCopy} from "react-icons/md";
import JsonViewer from "./JsonViewer";
import MarkdownViewer from "./MarkdownViewer";

const ResultSection = ({testResult, setShowResult, currentView, setCurrentView}) => {
    const [currentTab, setCurrentTab] = useState("Markdown");
    const [copyStatus, setCopyStatus] = useState("Copy");

    const downloadJSON = () => {
        if (testResult) {
            const blob = new Blob([JSON.stringify(testResult, null, 2)], {type: "application/json"});
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "testResult.json"; // Name of the file to be downloaded
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url); // Clean up the URL object
        }
    };
    const copyToClipboard = () => {
        if (testResult) {
            const jsonString = JSON.stringify(testResult, null, 2);
            navigator.clipboard
                .writeText(jsonString)
                .then(() => {
                    setCopyStatus("Copied"); // Update the button status
                    setTimeout(() => setCopyStatus("Copy"), 2000); // Reset status after 2 seconds
                })
                .catch((err) => {
                    console.error("Failed to copy: ", err);
                });
        }
    };

    return <div className={'px-3'}>
        <div className={'my-1 h-8 flex justify-between'}>
            <Segmented options={['Markdown', 'JSON']} onChange={setCurrentTab} defaultValue={currentTab}/>
            <button className={'bg-gray-100 hover:bg-gray-200 rounded-lg px-4'}
                    onClick={() => setShowResult(false)}>Close
            </button>
        </div>
        <div className={'border rounded-lg'}>
            {currentTab === "Markdown" ? (
                <div className={'overflow-auto'} style={{height: 'calc(100dvh - 10rem)'}}>
                    <MarkdownViewer data={testResult} currentView={currentView} setCurrentView={setCurrentView}/>
                </div>
            ) : (
                <div className={'relative'}>
                    <div className={'flex space-x-1 absolute top-2 right-4 z-10'}>
                        <button
                            className="flex items-center space-x-1 px-2 py-0.5 border rounded text-xs bg-white hover:bg-blue-100"
                            onClick={copyToClipboard}
                        >
                            <MdContentCopy/>
                            <p>{copyStatus}</p>
                        </button>
                        <button
                            className="flex items-center space-x-1 px-2 py-0.5 border rounded text-xs bg-white hover:bg-blue-100"
                            onClick={downloadJSON}
                        >
                            <AiOutlineDownload/>
                            <p>Download JSON</p>
                        </button>
                    </div>
                    <div className={'overflow-auto'} style={{height: 'calc(100dvh - 10rem)'}}>
                        <JsonViewer data={testResult}/>
                    </div>
                </div>
            )}
        </div>
    </div>
}

export default ResultSection
